module.exports = __webpack_public_path__ + "img/Settings-alt.26a65d3c.svg";